import axios, { type AxiosRequestConfig } from 'axios';

export default async (nonAgentId: string) => {
  const config: AxiosRequestConfig = {
    url: `/nonagent/${nonAgentId}`,
    method: 'delete',
  };

  await axios.request(config);
};
